import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlueprintBlogArticle, LazyBlueprintBusinessReport, LazyBlueprintBusinessReportDetail, LazyBlueprintPage, LazyHeroBlogArticle, LazyHeroBusinessReport, LazyHeroBusinessReportDetail, LazyHeroContent, LazyHeroDetail, LazyHeroHome, LazyHeroStandard, LazyAccordion, LazyCards, LazyCardsHover, LazyChartBar, LazyChartCircle, LazyChartLine, LazyDownloads, LazyFacts, LazyHighlight, LazyImage, LazyImageWithText, LazyInteractiveDocument, LazyOverviewBlog, LazyOverviewPools, LazyOverviewTeam, LazyQuotes, LazyShowMeMore, LazyTable, LazyTeaserBlog, LazyTeaserContact, LazyTeaserGeneral, LazyTeaserMap, LazyText, LazyTextHighlighted, LazyVideo, LazyVideoGallery, LazyBrCards, LazyBrDownload, LazyBrFacts, LazyBrHighlight, LazyBrImage, LazyBrLineChart, LazyBrQuote, LazyBrShowMeMore, LazyBrTable, LazyBrText, LazyIconArrowDown, LazyIconArrowLink, LazyIconArrowLinkBubble, LazyIconArrowLinkRight, LazyIconBurger, LazyIconCalendar, LazyIconCheck, LazyIconChevron, LazyIconDownload, LazyIconFacebook, LazyIconFile, LazyIconInstgram, LazyIconLinkedin, LazyIconLogo, LazyIconMagnifyingGlass, LazyIconMinus, LazyIconPlay, LazyIconPlus, LazyIconQuote, LazyIconReset, LazyIconSpin, LazyIconX } from '#components'
const lazyGlobalComponents = [
  ["BlueprintBlogArticle", LazyBlueprintBlogArticle],
["BlueprintBusinessReport", LazyBlueprintBusinessReport],
["BlueprintBusinessReportDetail", LazyBlueprintBusinessReportDetail],
["BlueprintPage", LazyBlueprintPage],
["HeroBlogArticle", LazyHeroBlogArticle],
["HeroBusinessReport", LazyHeroBusinessReport],
["HeroBusinessReportDetail", LazyHeroBusinessReportDetail],
["HeroContent", LazyHeroContent],
["HeroDetail", LazyHeroDetail],
["HeroHome", LazyHeroHome],
["HeroStandard", LazyHeroStandard],
["Accordion", LazyAccordion],
["Cards", LazyCards],
["CardsHover", LazyCardsHover],
["ChartBar", LazyChartBar],
["ChartCircle", LazyChartCircle],
["ChartLine", LazyChartLine],
["Downloads", LazyDownloads],
["Facts", LazyFacts],
["Highlight", LazyHighlight],
["Image", LazyImage],
["ImageWithText", LazyImageWithText],
["InteractiveDocument", LazyInteractiveDocument],
["OverviewBlog", LazyOverviewBlog],
["OverviewPools", LazyOverviewPools],
["OverviewTeam", LazyOverviewTeam],
["Quotes", LazyQuotes],
["ShowMeMore", LazyShowMeMore],
["Table", LazyTable],
["TeaserBlog", LazyTeaserBlog],
["TeaserContact", LazyTeaserContact],
["TeaserGeneral", LazyTeaserGeneral],
["TeaserMap", LazyTeaserMap],
["Text", LazyText],
["TextHighlighted", LazyTextHighlighted],
["Video", LazyVideo],
["VideoGallery", LazyVideoGallery],
["BrCards", LazyBrCards],
["BrDownload", LazyBrDownload],
["BrFacts", LazyBrFacts],
["BrHighlight", LazyBrHighlight],
["BrImage", LazyBrImage],
["BrLineChart", LazyBrLineChart],
["BrQuote", LazyBrQuote],
["BrShowMeMore", LazyBrShowMeMore],
["BrTable", LazyBrTable],
["BrText", LazyBrText],
["IconArrowDown", LazyIconArrowDown],
["IconArrowLink", LazyIconArrowLink],
["IconArrowLinkBubble", LazyIconArrowLinkBubble],
["IconArrowLinkRight", LazyIconArrowLinkRight],
["IconBurger", LazyIconBurger],
["IconCalendar", LazyIconCalendar],
["IconCheck", LazyIconCheck],
["IconChevron", LazyIconChevron],
["IconDownload", LazyIconDownload],
["IconFacebook", LazyIconFacebook],
["IconFile", LazyIconFile],
["IconInstgram", LazyIconInstgram],
["IconLinkedin", LazyIconLinkedin],
["IconLogo", LazyIconLogo],
["IconMagnifyingGlass", LazyIconMagnifyingGlass],
["IconMinus", LazyIconMinus],
["IconPlay", LazyIconPlay],
["IconPlus", LazyIconPlus],
["IconQuote", LazyIconQuote],
["IconReset", LazyIconReset],
["IconSpin", LazyIconSpin],
["IconX", LazyIconX],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
